import React from "react";
import { Script } from "gatsby";
import { toPlainText } from "@portabletext/react";
import { SITE_URL } from "utils/constants";

const mapOptionName = (name) => name.replace("Light ", "").toLowerCase();

const schemaOrgOptions = ["color", "size"];

const ProductRichSnippet = ({ product }) => {
	const structuredData = {
		"@context": "https://schema.org/",
		"@type": "ProductGroup",
		name: product.title,
		image: product.previewImageUrl,
		sku: product.variant.sku,
		brand: {
			"@type": "Brand",
			name: "MOD Lighting",
		},
		url: `${SITE_URL}/products/${product.handle}`,
		productGroupID: product.id,
		variesBy: product.options.map(option => "https://schema.org/" + mapOptionName(option.name)),
		aggregateRating: {
			"@type": "AggregateRating",
			description: "Okendo Reviews",
			ratingValue: product.reviewAggregate?.averageRating,
			reviewCount: product.reviewAggregate?.reviewCount,
		},
		hasVariant: product.variants.map((variant, index) => ({
			"@type": "Product",
			name: variant.title,
			sku: variant.sku,
			...Object.fromEntries(product.options.map((option, index) => {
				const optionValue = variant.store[`option${index + 1}`];
				const optionName = mapOptionName(option.name);
				if (schemaOrgOptions.includes(optionName))
					return [optionName, optionValue];
				else
					return null;
			}).filter(Boolean)),
			image: variant.image?.src || product?.previewImageUrl,
			offers: {
				"@type": "Offer",
				price: variant.price,
				priceCurrency: "USD",
				url: `${SITE_URL}/products/${product.handle}${index > 0 ? `/${variant.handle}` : ""}`,
				itemCondition: "https://schema.org/NewCondition",
				availability: "https://schema.org/" +
					(variant.availability?.preorder ? "Preorder" : variant.isAvailable ? "InStock" : "OutOfStock"),
			},
		}),
		)
	};

	if (product?.description) {
		const description = toPlainText(product.description);
		structuredData.description = description;
		structuredData.hasVariant?.forEach((variant) => variant.description = description);
	}

	return <Script async type="application/ld+json">{JSON.stringify(structuredData)}</Script>;
};

export default ProductRichSnippet;
